/**
 * Сервис для проверки информации о браузере и его возможностях
 * @class BrowserInfo
 */

import * as _ from 'lodash';
import UAParser from 'ua-parser-js';

export default angular.module('cian.newbuild.filter.browserInfoService', [])
  .factory('BrowserInfo', ['$window', $window => {
    const ua = $window.navigator.userAgent;
    const uaParser = new UAParser();

    return {
      /** @type {boolean} */
      isIE: ua.match(/msie/) || ua.match(/Trident.*rv\:11\./),
      isMobile: uaParser.getDevice().type === 'mobile',
      isTablet: uaParser.getDevice().type === 'tablet',
      /**
       * @param {string} browserName
       * @returns {boolean}
       */
      browserIs: browserName => uaParser.getBrowser().name === browserName,
      /**
       * Поддерживает ли браузер CSS-параметр или конкретное значение
       * @param {string} property
       * @param {?string} value
       * @returns {boolean}
       */
      supportsCSS: (property, value) => {
        if (angular.isUndefined(value)) {
          const prefixedProps = [
            'Webkit' + _.capitalize(property),
            'Moz' + _.capitalize(property),
            'O' + _.capitalize(property),
            property,
          ];
          return _.some(prefixedProps, prop => prop in $window.document.body.style)
        } else {
          // Source: http://albertogasparin.it/articles/2014/04/detect-css-support-of-property-value/
          const el = document.createElement('test');
          const mStyle = el.style;
          const prefixes = ['-webkit-', '-moz-', '-ms-', '-o-', ''];
          mStyle.cssText = _.reduce(prefixes,
            (result, prefix) => result + `${property}:${prefix + value};`,
            ''
          );

          return !!mStyle[property];
        }
      },
    };
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/browser-info.service.js